<template>
    <div class="case">
        <div class="case-container">
            <h1>/ Web Design /</h1>
            <!-- <p class="case-intro">Some of the Web design Cases</p> -->
            <h2>Weather.yours - A weather forecast website</h2>
            <img src="../../assets/weatheryours.jpg" alt="">
            <div class="gap"></div>
            <h2>Lun's resort - Luxury Resort website</h2>
            <img src="../../assets/lunsresort.jpg" alt="">
            <!-- <p>Here is the Figma prototypes:</p>
            <div class="figma">
                <iframe style="border: none;" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FJZfYWOvu5FCk7HkUhkNGEb%2F%25E9%25BA%2597%25E5%25AC%25B0%25E6%2588%25BF%3Fnode-id%3D68%253A105%26viewport%3D240%252C341%252C0.06829006224870682%26scaling%3Dscale-down" allowfullscreen></iframe>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            test:'test'
        }
    }
    
}
</script>
<style lang="scss" scoped>
    
</style>